export const GET_ALL_COURSE_PRICES = "GET_ALL_COURSE_PRICES";
export const ADMIN_COURSE_PRICE_CRUD = "ADMIN_COURSE_PRICE_CRUD"